import "./desktop-design.css";
import { PushEnablePrompt } from "../notifications/PushEnablePrompt";
import { RoleSession } from "./RoleSession";
import { RoleGate } from "./RoleGate";
import { useNavigationTrail } from "../misc/useReturnToPrevious";
import { useRevealMotion } from "../root/useRevealMotion";
import { CreationProvider } from "../misc/CreationProvider";
import { useLocation } from "react-router";
import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Notification } from "@/components/admin/notification";
import { Error } from "@/components/admin/error";
import { Skeleton } from "@/components/ui/skeleton";

import { DataImportProvider } from "../dataImport/DataImportProvider";
import { useConfigurationLoader } from "../root/useConfigurationLoader";
import Header from "./Header";
import { useApplyFontPreference } from "../root/useFontPreference";

import { useApplyMotionPreference } from "../root/MotionPreference";

export const Layout = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  useNavigationTrail();
  useConfigurationLoader();
  useApplyFontPreference();
  useApplyMotionPreference();
  useRevealMotion();
  return (
    <DataImportProvider>
      <CreationProvider>
        <RoleSession />
        <PushEnablePrompt />
        <Header />
        <main
          className="rovero-workspace max-w-screen-xl mx-auto p-4"
          id="main-content"
        >
          <ErrorBoundary FallbackComponent={Error}>
            <Suspense
              fallback={<Skeleton className="h-12 w-12 rounded-full" />}
            >
              <div
                key={location.pathname.split("/")[1] || "dashboard"}
                className="rovero-page"
              >
                <RoleGate>{children}</RoleGate>
              </div>
            </Suspense>
          </ErrorBoundary>
        </main>
        <Notification />
      </CreationProvider>
    </DataImportProvider>
  );
};
